module.exports = __webpack_public_path__ + "assets/b63d66718ba5c8627f6199ba0b758d07.png";